<div
  class="error-notice-card mat-elevation-z2 fadeinanimation p-20 mb-15"
  fxLayout="row"
  fxLayoutAlign="center center"
  *ngIf="error"
>
  <mat-icon class="material-icons mr-10 color--orange">{{ "warning" | translate }}</mat-icon>
{{ error | translate }}
</div>
